import { render, staticRenderFns } from "./studentCert.vue?vue&type=template&id=e24d5470"
import script from "./studentCert.vue?vue&type=script&lang=js"
export * from "./studentCert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports